import * as Cases from '../slices/casesSlice';
import { useAppDispatch } from '../slices/index';
import CaseListExpand from './caselistexpand';
import DonutChart from './donutchart';
import { ChartData } from "./donutchart";

const CaseListItem = (item: Cases.caseListState) => {
	const dispatch = useAppDispatch();

	const actionOnRow = (item: Cases.caseListState) => {
		dispatch(Cases.selectCase(item.caseno));
	}

	return (
		<div className="row">
			{(item.visible) &&
				<div className="hover" style={{ padding: 4, borderBottom: '1px solid #F4941E', color: 'black', fontSize: 13 }} onClick={() => actionOnRow(item)}>
					<div style={{ alignItems: 'center' }} className="row100" key={item.caseno}>
						<div className="flexGrow1" style={{ padding: '4px 0', overflow: 'hidden', textOverflow: 'ellipsis' }}>
							<div style={{ marginLeft: 8, marginRight: 8, width: '100%', display: 'flex', alignItems: 'center', gap: '10px' }}>{item.caseno}
								{item.unviewActions.length > 0 && <div style={{ height: '16px', width: '16px', backgroundColor: 'red', borderRadius: '50%', color: '#FFFFFF', fontSize: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{item.unviewActions.length}</div>}
							</div>
						</div>
						<div className="flexGrow1" style={{ padding: '4px 0', overflow: 'hidden', textOverflow: 'ellipsis' }}>
							<div style={{ marginLeft: 8, marginRight: 8, width: '100%', alignItems: 'center' }}>{item.type === "SecuredLending" ? "Secured Lending" : item.type}</div>
						</div>
						<div className="flexGrow1" style={{ padding: '4px 0', overflow: 'hidden', textOverflow: 'ellipsis' }}>
							<div style={{ marginLeft: 8, marginRight: 8, width: '100%', alignItems: 'center' }}>{item.opened}</div>
						</div>
						<div className="flexGrow2" style={{ padding: '4px 0', overflow: 'hidden', textTransform: 'capitalize', textOverflow: 'ellipsis' }}>
							<div style={{ marginLeft: 8, marginRight: 8, width: '100%', alignItems: 'center' }}>{item.description}</div>
						</div>
						<div className="flexGrow2" style={{ padding: '4px 0', overflow: 'hidden', textOverflow: 'ellipsis' }}>
							<div style={{ marginLeft: 8, marginRight: 8, width: '100%', alignItems: 'center' }}>{item.site}</div>
						</div>
						<div className="flexGrow3" style={{ padding: '4px 0', overflow: 'hidden', textOverflow: 'ellipsis' }}>
							<div style={{ marginLeft: 8, marginRight: 8, width: '100%', alignItems: 'center' }}>{item.address}</div>
						</div>
						<div className="flexGrow1" style={{ padding: '4px 0', overflow: 'hidden', textOverflow: 'ellipsis' }}>
							<div style={{ marginLeft: 8, marginRight: 8, width: '100%', alignItems: 'center' }}>{item.wishlisted}</div>
						</div>
						<div className="flexGrow1" style={{ padding: '4px 0', overflow: 'hidden', textOverflow: 'ellipsis' }}>
							<div style={{ marginLeft: 8, marginRight: 8, width: '100%', alignItems: 'center' }}>
								<DonutChart data={ChartData(item)} size={36} />
							</div>
						</div>
					</div>
					<CaseListExpand {...item} />
				</div>
			}
		</div>
	);
}

export default CaseListItem;